import React from 'react';
import { ColoredIcon } from '../components/ColoredIcon';
import { getIconCategory, getIconAriaLabel } from '../constants/iconMapping';

/**
 * Componente auxiliar para renderizar ícones coloridos no menu
 * Converte ícones Material-UI para ColoredIcon com categoria apropriada
 * 
 * @param {string} iconName - Nome do ícone Material-UI (ex: "Dashboard", "Settings")
 * @param {string} [ariaLabel] - Rótulo acessível customizado
 * @param {boolean} [animated] - Se deve aplicar animação de hover
 * @returns {JSX.Element} Componente ColoredIcon
 */
export const ColoredMenuIcon = ({ 
  iconName, 
  ariaLabel, 
  animated = true 
}) => {
  const category = getIconCategory(iconName);
  const defaultAriaLabel = getIconAriaLabel(iconName);
  const finalAriaLabel = ariaLabel || defaultAriaLabel || iconName;

  return (
    <ColoredIcon
      iconName={iconName}
      category={category}
      size={24}
      animated={animated}
      ariaLabel={finalAriaLabel}
      interactive={true}
    />
  );
};

export default ColoredMenuIcon;
